import React, { useRef, useState, useEffect } from 'react'
import { Tooltip } from 'antd'

const UMToolTip = ({ children }) => {
  const cellRef = useRef()
  const [isOverflowing, setIsOverflowing] = useState(false)

  const isContentOverflowing = (element) => {
    return element.scrollWidth > element.clientWidth
  }

  useEffect(() => {
    if (cellRef.current) {
      setIsOverflowing(isContentOverflowing(cellRef.current))
    }
  }, [cellRef])

  return (
    <Tooltip title={isOverflowing ? children : ''} mouseEnterDelay={0.3}>
      <span ref={cellRef} className='ellipsis-cell'>
        {children}
      </span>
    </Tooltip>
  )
}

export default UMToolTip
